const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CATEGORIES = ["AC", "Kelistrikan Dalam Gedung (Indoor)", "Kelistrikan Luar Gedung (Outdoor)", "Elektronik", "Kelistrikan", "Lainnya"];

export const LANTAI_OPTIONS = ["Lantai 1", "Lantai 2", "Lantai 3", "Lantai 4", "Area Luar", "-"];

export const KONDISI_OPTIONS = ["Normal", "Perlu Service", "Rusak"];

export const KONDISI_CONFIG = {
  Normal: { badge: "bg-emerald-100 text-emerald-800 border-emerald-200", icon: "ph-check-circle" },
  "Perlu Service": { badge: "bg-amber-100 text-amber-800 border-amber-200", icon: "ph-wrench" },
  Rusak: { badge: "bg-rose-100 text-rose-800 border-rose-200", icon: "ph-warning-octagon" },
};

export const TRIWULAN_OPTIONS = [1, 2, 3, 4];

export const triwulanLabel = (job) =>
  job && job.triwulan
    ? `Triwulan ${job.triwulan}${job.tahun ? ` - ${job.tahun}` : ""}`
    : "Tanpa Triwulan";

export const STATUSES = [
  "Selesai",
  "Dalam Proses",
  "Belum Dikerjakan",
  "Perlu Follow Up",
];

export const STATUS_CONFIG = {
  Selesai: { badge: "bg-emerald-100 text-emerald-800 border-emerald-200", icon: "ph-check-circle" },
  "Dalam Proses": { badge: "bg-amber-100 text-amber-800 border-amber-200", icon: "ph-spinner-gap" },
  "Belum Dikerjakan": { badge: "bg-slate-100 text-slate-700 border-slate-300", icon: "ph-circle-dashed" },
  "Perlu Follow Up": { badge: "bg-blue-100 text-blue-800 border-blue-200", icon: "ph-arrow-circle-right" },
};

export const CATEGORY_CONFIG = {
  AC: { badge: "bg-cyan-100 text-cyan-800 border-cyan-300", icon: "ph-snowflake" },
  "Kelistrikan Dalam Gedung (Indoor)": { badge: "bg-amber-100 text-amber-800 border-amber-300", icon: "ph-lightning" },
  "Kelistrikan Luar Gedung (Outdoor)": { badge: "bg-orange-100 text-orange-800 border-orange-300", icon: "ph-lightning" },
  Elektronik: { badge: "bg-violet-100 text-violet-800 border-violet-300", icon: "ph-television-simple" },
  Kelistrikan: { badge: "bg-amber-100 text-amber-800 border-amber-300", icon: "ph-lightning" },
  Lainnya: { badge: "bg-slate-100 text-slate-700 border-slate-300", icon: "ph-wrench" },
};

export const photoSrc = (photo) => {
  if (!photo) return null;
  if (photo.startsWith("http") || photo.startsWith("data:")) return photo;
  return `${BACKEND_URL}${photo}`;
};

export const waLink = (number, text) => {
  const clean = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export const formatRp = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");
export const itemCost = (item) =>
  (item.costs || []).reduce((s, c) => s + (Number(c.price) || 0) * (Number(c.qty) || 0), 0);
export const jobCost = (job) => (job.items || []).reduce((s, it) => s + itemCost(it), 0);
